import Customers from "./Customers";
import Discount from "./Discount";
import Membership from "./Membership";
import Promo from "./Promo";

export default { Customers, Membership, Promo, Discount };
